import { connection } from '../../utils/connection';
import { AUTH_URL } from '../../config/config';

async function forgotPasswordService(params) {
    return await connection({ method: 'POST', url: `${AUTH_URL.FORGOT_PASSWORD}`, params: params });
}

export default forgotPasswordService;
